<template>
    <div>
        <div class="content-caption dashed">基础信息</div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发起人</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{ comUserInfo.name || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发起部门</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-model="departId" placeholder="请选择">
                        <el-option v-for="item in comUserInfo.departs" :key="item.idX" :label="item.name" :value="item.idX"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">业务类型</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-model="bizScenario" placeholder="请选择" @change="changeBizScenario()">
                        <el-option v-for="item in bizScenarioList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <template v-if="decisionBasisVList.length > 0">
                <div class="form-group center" v-for="decisionBasis in decisionBasisVList">
                    <div class="form-label">
                        <label class="required">{{ decisionBasis.groupTitle || '' }}</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-select v-model="decisionBasis.checkedVal" placeholder="请选择">
                            <el-option v-for="item in decisionBasis.itemList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox } from '../../app.vues'

import oaAuditApi from '../../api/oaAudit'
import { getMerchtAuditBpConfInfo } from './selectDlg';
import merchtComnApi from '../../api/merchtComn';

export default {
    name: 'swb-fei-shu-audit-view',
    desc: '飞书审批预览',
    props: {
        bizTypeCode: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            comUserInfo: {},
            departId: null,
            bizScenario: null,
            bizScenarioList: [],    // 业务类型
            bizScenarioToBasisVMap: {},
            decisionBasisVList: []
        }
    },
    created: function () {
        if(Utils.isNoB(this.bizTypeCode)) {
            MsgBox.warning('参数异常，未知审批业务');
            return;
        }
        this.getFeiShuUserDetail();
        //
        this.getMerchtAuditBpConfList();
    },
    methods: {
        getFeiShuUserDetail: function () {
            let self = this;
            let params = {
                withDepartDetails: true
            };
            let theLoad = MsgBox.loading();
            oaAuditApi.getFeiShuUserDetail(params, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let comUserInfo = result.data || {};
                    if(!Utils.isNoB(comUserInfo.departs) && comUserInfo.departs.length > 0) {
                        self.departId = comUserInfo.departs[0].idX;
                    }
                    self.comUserInfo = comUserInfo;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 获取业务类型列表
        getMerchtAuditBpConfList: function () {
            let params = {
                bizTypeCode: this.bizTypeCode,
                chanel: 3,   // 飞书
                ready: true
            };
            let theLoad = MsgBox.loading();
            oaAuditApi.getMerchtAuditBpConfList(params, (result) => {
                theLoad.hide();
                if(result.type === 'info') {
                    let bpConfList = result.data || [];
                    if(bpConfList.length > 0) {
                        let bizScenarioList = [];
                        for(let i = 0; i < bpConfList.length; i++) {
                            bizScenarioList.push({
                                name: bpConfList[i].bizScenario,
                                value: bpConfList[i].bizScenario
                            })
                        }
                        this.bizScenarioList = Utils.merge([], bizScenarioList);
                        this.bizScenarioToBasisVMap = bpConfList.toMap('bizScenario');
                        // 默认选中
                        if(bpConfList.length === 1) {
                            let bpConfInfo = bpConfList[0];
                            //
                            this.bizScenario = bpConfInfo.bizScenario;
                            this.decisionBasisVList = Utils.merge([], JSON.decode(bpConfInfo.decisionBasis));
                        }
                    } else {
                        MsgBox.warning('未找到对应的流程配置信息');
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        changeBizScenario: function () {
            let bizScenario = this.bizScenario;
            let bizScenarioToBasisVMap = this.bizScenarioToBasisVMap;
            //
            this.decisionBasisVList = Utils.merge([], JSON.decode(bizScenarioToBasisVMap[bizScenario].decisionBasis));
        },
        // getDecisionBasisVList: function () {
        //     let self = this;
        //     // 飞书审批流程配置
        //     getMerchtAuditBpConfInfo(this.bizTypeCode, false, function (auditBpConfInfo) {
        //         if(auditBpConfInfo.chanel == 3 && auditBpConfInfo.ready) {
        //             //
        //             self.decisionBasisVList = Utils.merge([], JSON.decode(auditBpConfInfo.decisionBasis));
        //         }
        //     });
        // },
        getDlgResult: function () {
            let result = {
                type: 'info'
            };
            if(Utils.isNoB(this.comUserInfo.id)) {
                result.type = 'warn';
                result.message = '未找到发起人信息';
            }
            let decisionBasisValMapList = [];
            let decisionBasisVList = this.decisionBasisVList || [];
            if(decisionBasisVList.length > 0) {
                // 检查并处理选中值
                let checkedWarnMsg = null;
                for(let i = 0; i < decisionBasisVList.length; i++) {
                    let decisionBasisV = decisionBasisVList[i];
                    if(Utils.isNoB(decisionBasisV.checkedVal)) {
                        checkedWarnMsg = '请选择【' + decisionBasisV.groupTitle + '】';
                        break;
                    } else {
                        let decisionBasisValMap = {};
                        decisionBasisValMap[decisionBasisV.variableName] = decisionBasisV.checkedVal;
                        //
                        decisionBasisValMapList.push(decisionBasisValMap);
                    }
                }
                if(!Utils.isNoB(checkedWarnMsg)) {
                    result.type = 'warn';
                    result.message = checkedWarnMsg;
                }
            }
            result.data = {
                userId: this.comUserInfo.id,
                departId: this.departId,
                decisionBasisVal: decisionBasisValMapList,
                bizScenario: this.bizScenario
            };
            return result;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/compo/oaAudit/FeiShuAuditView.vue